import { InjectionToken } from '@angular/core';

export const HISTORY_API_BASE_URL = new InjectionToken<string>('HISTORY_API_BASE_URL');
